import { Box, Accordion, AccordionSummary, AccordionDetails, Grid2 as Grid, Typography, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import ErrorIcon from "@mui/icons-material/Error";
import { useStyles } from "./Invoice.styles";
import { ManualHeaderDetailsProps } from "./types";
import { AlertInformation } from "../AlertInformation/AlertInformation";
import CopyToClipboard from "../CopyToClipboard/CopyToClipboard";
import { useState, useCallback } from "react";
export const ManualHeaderDetails = ({
	purchaseOrder,
	onExpandClick,
	showLock,
	isLocked,
	isExpanded,
	alert,
}: ManualHeaderDetailsProps) => {
	const classes = useStyles();
	const [asnDetailsModalOpen, setAsnDetailsModalOpen] = useState(false);
	
	const onAsnDetailsModalOpen = useCallback(() => {
		setAsnDetailsModalOpen(true);
	}, []);
	
	const onAsnDetailsModalClose = useCallback(() => {
		setAsnDetailsModalOpen(false);
	}, []);

	return (
		<>
			<Accordion
				defaultExpanded
				expanded={isExpanded}
				onChange={() => onExpandClick({} as React.MouseEvent<HTMLButtonElement>)}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="manualheaderdetails-content"
					id="manualheaderdetails"
					className={classes.manualCollapsePanelSummary}
				>
					<Grid container alignItems="center" sx={{ width: "100%" }}>
						<Grid size="auto">
							<Typography variant="caption" color="textSecondary" display="inline">
								PO No:
								{purchaseOrder.sourceId && (
									<>
										<Typography variant="body2" display="inline" color="textPrimary">
											{" " + purchaseOrder.sourceId}
										</Typography>
										<CopyToClipboard text={purchaseOrder.sourceId} />
									</>
								)}
							</Typography>
						</Grid>
						<Grid container size="grow" justifyContent="flex-end">
							{alert?.show && !isExpanded && (
								<Grid>
									<ErrorIcon className={classes.icon} />
								</Grid>
							)}
							{showLock && <Grid>{isLocked ? <LockIcon /> : <LockOpenIcon />}</Grid>}
						</Grid>
					</Grid>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container size={12} direction="column">
						<Box>
							<Typography variant="caption" display="inline">
								PO Status:
							</Typography>
							<Typography variant="body2" display="inline">
								{" " + purchaseOrder.status}
							</Typography>
						</Box>
						<Box>
							<Typography variant="caption" display="inline">
								Store:
							</Typography>
							<Typography variant="body2" display="inline">
								{" " + purchaseOrder.shipToLocation.companyName}
							</Typography>
						</Box>
						<Box>
							<Typography variant="caption" display="inline">
								Supplier:
							</Typography>
							<Typography variant="body2" display="inline">
								{" " + purchaseOrder.vendorName}
							</Typography>
						</Box>
						<Box>
							<Typography variant="caption" display="inline">
								Invoice Type:
							</Typography>
							<Typography variant="body2" display="inline">
								{" " + (purchaseOrder.isEdi ? "EDI" : "Manual")}
							</Typography>
						</Box>
						{alert?.show && (
							<Box className={classes.alert}>
								<AlertInformation severity={alert.severity} message={alert.message} title={alert.title} />
							</Box>
						)}
					</Grid>
				</AccordionDetails>
			</Accordion>
		</>
	);
};
